module.exports = __webpack_public_path__ + "static/media/combo-ruoc-lap-xuong.88ea4767.jpg";